import {
	GET_INVOICES,
} from '../../Actions/Admin/ManageInvoiceActions';

const initialState = {
	invoices: [],
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_INVOICES:
			return {
				...state,
				loading: true,
				invoices: action.payload
			};
		default:
			return state;
	}
};
